import { Component, OnInit, Inject, ViewChild, TemplateRef, Output, EventEmitter, Input, Injector } from '@angular/core';
import LanguagesListComponentView from './languages-list.component.html';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { TranslateService, _ } from '@ngx-translate/core';
import { AuthService } from '../../../../core/services/auth.service';

import { LogService } from '../../../../core/services/log.service';
import { Language } from '../../../../shared/models/common/language.model';
import { Table } from 'primeng/table';
import { GridConfig } from '../../../../shared/components/grid/models/grid-config.model';
import { LanguagesService } from '../../services/languages.service';

@Component({
    selector: 'languages-list',
    template: LanguagesListComponentView
})

export class LanguagesListComponent implements OnInit {

    private allowWrite: boolean = false;

    @ViewChild('activeTemplate', { static: true }) activeTemplate!: TemplateRef<any>;

    private gridConfig: GridConfig = {
        columns: []
    };

    private searchValue: string = '';

    private languages: Language[];

    private getLanguages() {
        this.LanguagesService.getAllLanguages().subscribe({
            next: (languagesData) => {
                this.languages = languagesData;
            },
            error: (err) => {
                console.error('Something went wrong... ', err);
            }
        })
    };

    private goToAdd() {
        this.$state.go("common.languages.edit");
    }

    private goToEdit(id) {
        // TODO Makinga a confirm modal
        this.$state.go("common.languages.edit", { id: id });
    }

    /*
    A petici�n de ORberto desactivamos el borrado de idiomas
    private checkDelete(language) {

        this.confirmationService.confirm({
            message: this.translate.instant(_('languages.management.check_delete')),
            header: this.translate.instant(_('general.remove')), 
            accept: () => {
                this.LanguagesService.deleteLanguage(language).subscribe({
                    next: () => this.getLanguages(),
                });
            },
            reject: () => {
                // Optional: action on reject (cancel)
            }
        });

    }
    */
    constructor(@Inject(LogService) private log: LogService,
        @Inject(LanguagesService) private LanguagesService: LanguagesService,
        @Inject(ConfirmationService) private confirmationService: ConfirmationService,
        @Inject(TranslateService) private translate: TranslateService,
        @Inject(AuthService) private authService: AuthService,
        @Inject('$stateParams') private $stateParams: any,
        @Inject('$state') private $state: any) {
    }

    ngOnInit() {

        this.allowWrite = this.authService.permissionExist('LANGUAGES_WRITE') ?? false;

        this.getLanguages();
        this.LanguagesService.showServiceMessage();

    }

    ngAfterViewInit() {

        this.gridConfig = {

            columns: [

                {
                    name: 'name',
                    header: { displayName: 'languages.management.name' },
                    type: 'text',
                    enableSorting: true,
                },
                {
                    name: 'native_name',
                    header: { displayName: 'languages.management.native_name', style: 'width: 150px; text-align: center;' },
                    type: 'text',
                    enableSorting: true
                },
                {
                    name: 'code',
                    header: { displayName: 'languages.management.code', style: 'width: 150px; text-align: center;' },
                    type: 'text',
                    enableSorting: true,
                },
                {
                    name: 'active',
                    header: { displayName: 'languages.management.active', style: 'width: 150px; text-align: center;' },
                    template: this.activeTemplate,
                    enableSorting: true,
                }

            ],
            actions: [

                {

                    label: 'general.edit',
                    icon: 'pi-pen-to-square',
                    command: (row) => this.goToEdit(row.id),
                    showCondition: (row) => this.allowWrite

                },
               /* 
               {

                    label: 'general.remove',
                    icon: 'pi pi-times',
                    severity: 'danger',
                    command: (row) => this.checkDelete(row),
                    showCondition: (row) => true

                }
                */
            ],

            globalFilterFields: ['name', 'native_name', 'code', 'active'],
            resizableColumns: true,
            sortMode: 'single',
            stateStorage: 'local',
            stateKey: 'languagesTable',
            enableSelection: false,
            sortField: 'name',
            sortOrder: -1,
            dataKey: 'id',
            customSort: false,
            showColumnSelector: false,
            showClearButton: false,
            showExportButton: false,
            showRefreshButton: true,

            refreshCallback: () => {

                this.LanguagesService.getAllLanguages();

            }

        };
    }

    clear(table: Table) {

        table.clear(); 
        table.filters = {}

    }
   
}
